import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// forceTZA was added because events team does not want to indicate daylight savings time
const createFormattedTimeRange = (starts: string, ends: string, timeZone: string, forceTZA?: string) => {
  const startDateUtc = new Date(starts);
  const endDateUtc = new Date(ends);
  const startDateLocal = utcToZonedTime(startDateUtc, timeZone);
  const endDateLocal = utcToZonedTime(endDateUtc, timeZone);
  const formattedStartDate = format(startDateLocal, 'h:mm a', {});
  const formattedEndDate = format(endDateLocal, 'h:mm a', {});
  const timezoneAbbreviation = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' }).format(startDateLocal).split(' ')[1];
  const formattedTimeRange = `${formattedStartDate} - ${formattedEndDate} ${!forceTZA ? timezoneAbbreviation : forceTZA}`;
  return formattedTimeRange;
};

export { createFormattedTimeRange };
